import { render, staticRenderFns } from "./guard_config_detail.vue?vue&type=template&id=84bc70ac&scoped=true"
import script from "./guard_config_detail.vue?vue&type=script&lang=js"
export * from "./guard_config_detail.vue?vue&type=script&lang=js"
import style0 from "./guard_config_detail.vue?vue&type=style&index=0&id=84bc70ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bc70ac",
  null
  
)

export default component.exports